import './directives'
import '../node_modules/bulma/css/bulma.css'
import './services'
import './common/inputs'
import './common/buttons'
import '../static/css/main.css'
import '../static/icones/icones.css'

import ES6Promise from 'es6-promise'
import _vue from 'vue'
import App from './App.vue'
import store from './store/store'
import router from './router/router'
import VueResource from 'vue-resource'
import VModal from 'vue-js-modal'
import swal from 'sweetalert2'
import i18n from './locales/i18n'

import { modalDeErro } from './utils'
import UsarSentry from './sentry'

const swalPlugin = {
  install: function (Vue: typeof _vue, options?: any) { Vue.prototype.$swal = swal }
}

_vue.use(swalPlugin)
_vue.use(VModal)
_vue.use(VueResource)
_vue.config.productionTip = false
_vue.prototype.$modalDeErro = modalDeErro

UsarSentry.inicializar(_vue, router)

ES6Promise.polyfill()

new _vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
